  <template>
  <div>
    <van-nav-bar
      title="资金明细"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/time_bao')"

    />
    <div class="">
      <van-row style="padding-top: 10px;"
        ><van-col span="3" class="rowStyle" style="text-align: center"
          ><span style="font-size: 13px">日期:</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                style="color: red"
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="2" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            type="danger"
            size="small"
            style="height: 30px; background-color: unset; color: #1989fa"
            @click="onSearchButton"
            >检索</van-button
          ></van-col
        >
      </van-row>
    </div>

    <div class="tableDetails">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="isLoading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMore"
          offset:50
          immediate-check:false
        >
          <div v-for="(item, index) in timebaoDetails" :key="index">
            <van-row class="rowDesign">
              <van-col span="12" style="text-align: left">
                <p style="margin: 0">{{ item.name }}</p>
                <p style="padding-top: 12px; margin: 0">
                  账户余额: {{ item.balance }}
                </p>
              </van-col>

              <van-col span="12" style="text-align: right">
                <van-row style="padding-bottom: 1px"
                  ><p style="margin: 0">{{ item.amount }}</p>
                  <p style="padding-top: 12px; margin: 0">
                    {{ item.time }}
                  </p></van-row
                >
              </van-col>
            </van-row>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeBao",
  data() {
    return {
      date: new Date(),
      isLoading: false,
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
      timebaoDetails: [],
      finished: false,
      refreshing: false,
      page: 0,
      num: 20,
    };
  },
  computed: {},
  methods: {
    onSearchButton(){
      this.page=0;
      this.timebaoDetails=[];
      this.finished=false;
      this.loadMore();
    },
    loadMore() {
      // console.log("here");
      this.isLoading = true;
      this.page++;
      this.getDetails();
    },
    onRefresh() {
      this.timebaoDetails = [];
      this.finished = false;
      this.page=0;
      this.refreshing = true;
      this.getDetails();
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
    getDetails() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "timebao_fund",
            token: sessionStorage.getItem("token"),
            action: "querylog",
            //   page: that.timebaoDetails.page,
            //   num:that.timebaoDetails.num,
            start: that.startDate,
            end: that.endDate,
            page: that.page,
            num: that.num,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            // that.timebaoDetails = resData.data;
            if (resData.data.length === 0) {
              that.finished = true;
            } else {
              resData.data.forEach((element) => {
                that.timebaoDetails.push(element);
              });
            }
            that.refreshing = false;
            that.isLoading = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.refreshing = false;
          that.isLoading = false;
          that.finished = true;
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  height: 50px;
  background: #ffffff;
  position: fixed;
  top: 42px;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.dateFilter {
  padding: 0px 5px;
  position: fixed;
  top: 56px;
  left: 0;
  width: 100%;
  /* border-bottom: 1px solid #ebedf0; */
  padding-bottom: 10px;
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableDetails {
  margin-top: 10px;
  font-size: 14px;
  padding: 0px 10px;
}

.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgb(200, 201, 204);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeBaoDetails.vue